<template>
  <div class="group-chat-box">
    <div class="box-shadow">
      <top-title name="群聊营销"></top-title>
      <div class="tip-box" v-if="isShowDongTip">
        <img src="@/assets/images/new_icon_reminder.png" alt="" />
        <span>注：创建群需要主账号登录京东客服管家，前往创建</span>
        <span class="url" @click="navigate">http://kf.jd.com</span>
        <span>（进入咚咚群管理-分类管理）</span>
        <el-button type="primary" plain @click="navigate">前往创建</el-button>
      </div>
      <div class="tab-line">
        <div
          class="tab-item"
          @click="handleSwitch(1)"
          :class="{ active: tabIndex == '1' }"
          :style="{
            color: tabIndex == '1' ? globalBG : '',
            'border-top': tabIndex == '1' ? '2px solid ' + globalBG : '',
          }"
        >
          群聊营销
          <span></span>
        </div>
        <div
          class="tab-item"
          @click="handleSwitch(2)"
          :class="{ active: tabIndex == '2' }"
          :style="{
            color: tabIndex == '2' ? globalBG : '',
            'border-top': tabIndex == '2' ? '2px solid ' + globalBG : '',
          }"
        >
          群发记录
          <span></span>
        </div>
      </div>
      <template v-if="tabIndex == '1'">
        <div class="step-box-total">
          <div class="step1-box">
            <div class="step-bar">
              <span class="serial" :style="{ background: globalBG }">1</span>
              <span class="name" style="margin-left: -10px">筛选群组</span>
            </div>
            <div class="form-item">
              <div class="item-label">群发主题：</div>
              <div class="item-value activity-theme">
                <el-input
                  placeholder="可不填"
                  v-model="formData.massTheme"
                  maxlength="50"
                  show-word-limit
                  :disabled="status === 'catch'"
                ></el-input>
              </div>
            </div>
            <div class="form-item">
              <div class="item-label">选择咚咚群组：</div>
              <div class="item-value">
                <div class="select-group-box">
                  <div class="select-header">
                    <el-button
                      class="add-btn"
                      @click="showGroup()"
                      :disabled="status === 'catch'"
                    >
                      <i class="iconfont iconbtn_zidingyitianjia"></i>
                      添加
                    </el-button>
                    <span>已选</span>
                    <span class="height-num" style="color: #fe4d45">{{
                      groupData.length
                    }}</span>
                    <span>个群聊</span>
                  </div>
                  <div
                    class="people-group"
                    v-if="groupData && groupData.length > 0"
                  >
                    <div
                      class="group-item"
                      v-for="(item, index) in groupData"
                      :key="index"
                    >
                      <div class="group-name">
                        {{ item.groupName }}
                      </div>
                      <div
                        v-if="status !== 'catch'"
                        class="close"
                        @click="delGroup(item, index)"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 编辑内容 -->
          <div class="step1-box edit-content">
            <div class="step-bar">
              <span class="serial" :style="{ background: globalBG }">2</span>
              <span class="name" style="margin-left: -10px">编辑内容</span>
            </div>
            <div class="form-item message-type">
              <div class="item-label">消息类型：</div>
              <div class="item-value">
                <el-radio-group
                  :disabled="status === 'catch'"
                  v-model="formData.messageType"
                >
                  <el-radio :label="0">图文消息</el-radio>
                  <el-radio :label="1">商品卡片</el-radio>
                </el-radio-group>
              </div>
            </div>
            <!-- 图文消息 -->
            <template v-if="formData.messageType === 0">
              <div class="form-item add-pic">
                <div class="item-label">
                  <el-checkbox
                    :disabled="status === 'catch'"
                    v-model="formData.addPicture"
                  ></el-checkbox>
                  添加图片
                </div>
              </div>
              <div class="form-item main-graph" v-if="formData.addPicture">
                <div class="item-label">推送主图：</div>
                <div class="item-value">
                  <div class="upload-wrap">
                    <el-upload
                      ref="upload"
                      action="#"
                      :show-file-list="false"
                      :auto-upload="false"
                      :limit="1"
                      accept=".jpg, .png"
                      :disabled="status === 'catch'"
                      :on-change="handleChange"
                    >
                      <img
                        class="upload-img"
                        v-if="formData.pushMainGraph"
                        :src="formData.pushMainGraph"
                        alt=""
                      />
                      <div v-else class="upload-box">
                        <i class="iconfont iconbtn_zidingyitianjia"></i>
                        <div class="text">上传图片</div>
                      </div>
                    </el-upload>
                    <div class="upload-limit">
                      <p>限制格式：jpg、png</p>
                      <p>请上传小于500k的图片</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-item add-pic">
                <div class="item-label">
                  <el-checkbox
                    :disabled="status === 'catch'"
                    v-model="formData.addText"
                  ></el-checkbox>
                  添加文本
                </div>
              </div>
              <div class="form-item" v-if="formData.addText">
                <div class="item-label">文本内容：</div>
                <div class="item-value">
                  <div class="textarea-wrap">
                    <el-input
                      v-model="formData.textMessageContent"
                      :disabled="status === 'catch'"
                      type="textarea"
                      maxlength="500"
                      rows="5"
                    ></el-input>
                    <div class="limit">
                      {{ formData.textMessageContent.length }}/500
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <!-- 商品卡片 -->
            <div class="shop-card" v-if="formData.messageType === 1">
              <div class="form-item">
                <div class="item-label">卡片标题：</div>
                <div class="item-value">
                  <el-input
                    placeholder=""
                    style="width: 500px"
                    :disabled="status === 'catch'"
                    v-model="formData.cardTitle"
                    maxlength="20"
                    show-word-limit
                  ></el-input>
                </div>
              </div>
              <div class="form-item master-map-push">
                <div class="item-label">推送主图：</div>
                <div class="item-value">
                  <div>
                    <el-button
                      class="add-good-btn"
                      @click="showGoodsDialog()"
                      :disabled="status === 'catch'"
                    >
                      <i class="iconfont iconbtn_zidingyitianjia"></i>
                      添加商品
                    </el-button>
                    <div class="add-shop-tip">
                      <img src="@/assets/images/new_icon_reminder.png" alt="" />
                      <span>注：每次最多添加4个商品</span>
                    </div>
                  </div>
                  <div class="goods-list" v-if="skuList && skuList.length > 0">
                    <div
                      class="goods-item"
                      v-for="(item, index) in skuList"
                      :key="index"
                    >
                      <div class="img-wrap">
                        <img :src="item.logo" alt="" />
                      </div>
                      <p>skuid:{{ item.skuId }}</p>
                      <el-tooltip
                        effect="light"
                        :content="item.skuName"
                        placement="top-start"
                      >
                        <p>{{ item.skuName }}</p>
                      </el-tooltip>
                      <div class="hover-show" v-if="status !== 'catch'">
                        <el-button
                          class="del"
                          type="primary"
                          @click="delItem(item, index)"
                          >删除</el-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-item">
                <div class="item-label">文本内容：</div>
                <div class="item-value">
                  <div class="textarea-wrap">
                    <el-input
                      v-model="formData.textMessageContent"
                      type="textarea"
                      maxlength="500"
                      :disabled="status === 'catch'"
                      rows="5"
                    ></el-input>
                    <div class="limit">
                      {{ formData.textMessageContent.length }}/500
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 手机预览 -->
            <div class="phone-wrap">
              <div class="phone-preview">
                <img class="bg" src="@/assets/images/group-chat.svg" alt="" />
                <div class="preview-text">咚咚群聊预览</div>
                <div class="content-wrap">
                  <!-- <div class="img-wrap" v-if="formData.messageType === 0 && formData.addPicture">
                    <img
                      class="upload-img"
                      v-if="formData.pushMainGraph"
                      :src="formData.pushMainGraph"
                      alt=""
                    />
                    <div v-else class="empty">-暂无活动主图-</div>
                  </div> -->
                  <div class="chat-record" v-if="formData.messageType === 0 && formData.addPicture && formData.pushMainGraph">
                    <div class="chat-item">
                      <img
                        class="chat-icon"
                        src="@/assets/images/chart.png"
                        alt=""
                      />
                      <div class="chat-right">
                        <div>
                          <img src="@/assets/images/group-l.svg" alt="">
                          <span class="shop-title">小云旗舰店</span>
                        </div>
                        <div class="img-wrap">
                          <img
                            class="upload-img"
                            v-if="formData.pushMainGraph"
                            :src="formData.pushMainGraph"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="chat-record" v-if="formData.messageType === 1">
                    <div class="chat-item"  v-if="
                            formData.cardTitle || (skuList && skuList.length > 0)
                          ">
                      <img
                        class="chat-icon"
                        src="@/assets/images/chart.png"
                        alt=""
                      />
                      <div class="chat-right">
                        <div>
                          <img src="@/assets/images/group-l.svg" alt="">
                          <span class="shop-title">小云旗舰店</span>
                        </div>
                        <div
                          class="message-content"
                          v-if="
                            formData.cardTitle || (skuList && skuList.length > 0)
                          "
                        >

                          <div class="card-title" v-if="formData.cardTitle">
                            {{ formData.cardTitle }}
                          </div>
                          <div
                            class="goods-record"
                            v-if="skuList && skuList.length > 0"
                          >
                            <div
                              class="record-item"
                              v-for="(item, index) in skuList"
                              :key="index"
                            >
                              <img :src="item.logo" alt="" />
                              <div class="detail">
                                <p>{{ item.skuName }}</p>
                                <p class="num">￥{{ item.jdPrice }}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="chat-record">
                    <div class="chat-item" v-if="formData.textMessageContent">
                      <img
                        class="chat-icon"
                        src="@/assets/images/chart.png"
                        alt=""
                      />
                      <div class="chat-right">
                        <div>
                          <img src="@/assets/images/group-l.svg" alt="">
                          <span class="shop-title">小云旗舰店</span>
                        </div>
                        <div
                          class="message-content"
                          v-if="(formData.textMessageContent && formData.messageType === 0 && formData.addText) || (formData.textMessageContent && formData.messageType === 1)"
                        >
                          {{ formData.textMessageContent }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 发送时间 -->
          <div :class="[adjustClass]" class="step1-box send">
            <div class="step-bar">
              <span class="serial" :style="{ background: globalBG }">3</span>
              <span class="name" style="margin-left: -10px">发送时间</span>
            </div>
            <div class="send-wrap">
              <el-radio-group
                v-model="formData.sendType"
                :disabled="status === 'catch'"
                @change="handleSendChange"
              >
                <el-radio :label="0"><span>立即发送</span></el-radio>
                <el-radio :label="1">
                  <span>定时发送</span>
                  <el-date-picker
                    v-model="formData.sendTime"
                    :disabled="!formData.sendType || status === 'catch'|| formData.sendType != 1"
                    :picker-options="disabledOption"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    style="width: 198px; margin-left: 10px"
                  ></el-date-picker>
                </el-radio>
                <el-radio :label="2">
                  <span>循环发送</span>
                </el-radio>
              </el-radio-group>
              <!-- 循环发送表单 -->
              <div class="circulateData" v-if="formData.sendType && formData.sendType === 2">
                <el-form :model="circulate" ref="circulate" label-width="120px" >
                  <el-form-item label="活动时间：">
                    <div class="my_select_time">
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="circulate.cycleStartTime"
                        type="date"
                        :placeholder="'开始日期'"
                        size="small"
                        format="yyyy-MM-dd"
                        :picker-options="startTimeCycle"
                        value-format="yyyy-MM-dd"
                        style="width: 100px; font-size: 12px;"
                        default-time="23:59:59"
                        class="time1"
                        :clearable="false"
                        :disabled="status === 'catch'"
                      ></el-date-picker>
                      <div class="time_to_text" style="margin-top: 1px !important">
                        至
                      </div>
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="circulate.cycleEndTime"
                        type="date"
                        :placeholder="'结束日期'"
                        :picker-options="endTimeCycle"
                        size="small"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 125px; font-size: 12px;"
                        default-time="23:59:59"
                        class="time2"
                        :clearable="false"
                        :disabled="status === 'catch'"
                      ></el-date-picker>
                      <i
                        class="el-icon-circle-close date_icon1"
                        @click="clearCycleTime()"
                        v-if="status !== 'catch'"
                      ></i>
                      <img
                        src="@/assets/images/select_date.svg"
                        alt
                        class="date_icon2"
                      />
                    </div>
                  </el-form-item>
                  <el-form-item label="推送时间：">
                    <el-radio-group
                      v-model="circulate.cycleExecutionType"
                      @change="handleDayChange"
                      :disabled="status === 'catch'"
                    >
                      <el-radio :label="0"><span>按天</span></el-radio>
                      <el-radio :label="1"><span>按周</span></el-radio>
                      <el-radio :label="2"><span>按月</span></el-radio>
                    </el-radio-group>
                  </el-form-item>
                    <!-- 按天 -->
                    <el-form-item v-if="circulate.cycleExecutionType === 0">
                    <span>每</span>
                      <el-input-number style="margin:0 10px" v-model="circulate.cycleDay" :min="1" :max="999" :disabled="status === 'catch'" ></el-input-number>
                    <span>天</span>
                    </el-form-item>

                    <!-- 按周 -->
                    <el-form-item v-if="circulate.cycleExecutionType === 1">
                      <div style="display: flex;">
                        <span style="width:50px">每周：</span>
                        <el-checkbox-group v-model="circulate.cycleDayWeekly" style="display:flex;width:30px;" :disabled="status === 'catch'">
                          <el-checkbox v-for="(item, index) in cycleDayWeeklys" :key="index" :label="item.value">{{item.label}}</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </el-form-item>

                    <!-- 按月 -->
                    <el-form-item v-if="circulate.cycleExecutionType === 2">
                      <div style="display: flex;">
                        <span style="width:150px">每月：</span>
                        <el-checkbox-group v-model="circulate.cycleDayMonthly" :disabled="status === 'catch'">
                          <el-checkbox v-for="day in cycleDayMonthlys" :label="day" :key="day" style="width:30px">{{day}}</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </el-form-item>

                    <el-form-item class="dayTimeSelect">
                     <div style="display:flex">
                        <div>每天推送时间点：</div>
                        <div style="position: relative;">
                          <el-time-picker
                            prefix-icon="no_icon"
                            v-model="circulate.cycleExecutionTime"
                            value-format="HH:mm:ss"
                            :picker-options="{
                              selectableRange: '00:00:00 - 23:59:59'
                            }"
                            :clearable="false"
                            :disabled="status === 'catch'"
                            placeholder="任意时间点">
                          </el-time-picker>
                          <i
                            class="el-icon-circle-close date_icon1"
                            @click="clearCycleSendTime()"
                            v-if="status !== 'catch'"
                          ></i>
                          <img
                            src="@/assets/images/select_date.svg"
                            alt
                            class="date_icon3"
                          />
                        </div>
                      </div>
                    </el-form-item>

                    <el-form-item v-if="circulate.cycleExecutionType === 0">
                      <div class="cycleTipbox">
                        <img src="@/assets/images/new_icon_reminder.png" alt=""/>
                        <span class="cont">例如1号开始发送，选择每1天，则每天都会发送；选择每2天，则下一次会在3号进行发送。</span>
                      </div>
                    </el-form-item>

                    <el-form-item v-if="circulate.cycleExecutionType === 2">
                      <div class="cycleTipbox">
                        <img src="@/assets/images/new_icon_reminder.png" alt=""/>
                        <span class="cont">如遇当月没有29、30、31的情况则会直接跳过不执行任务</span>
                      </div>
                    </el-form-item>

                </el-form>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部发送 -->
        <footer class="foot">
          <el-button
            type="primary"
            @click="handleReturn"
            v-if="status === 'catch'"
            >返回</el-button
          >
          <template v-if="status === '' || status === 'copy'">
            <el-button
              type="primary"
              v-loading="draftLoading"
              @click="handleSaveDraft"
              >保存草稿</el-button
            >
            <el-button
              class="sendTest"
              style="
                margin-right: 100px;
                border: 1px solid #fe4d45;
                color: #fe4d45;
              "
              @click="clearAll"
              >一键清空</el-button
            >
            <el-button
              class="btn"
              type="primary"
              v-loading="sendLoading"
              @click="handleSubmit"
              >提交发送</el-button
            >
          </template>
        </footer>
      </template>
      <!-- 群发记录 -->
      <template v-if="tabIndex == '2'">
        <div class="form-box">
          <el-form
            ref="formSearch"
            :inline="true"
            :model="form"
            label-width="120px"
          >
            <el-form-item label="群发主题：">
              <el-input
                size="small"
                v-model="form.massTheme"
                placeholder="请输入群发主题"
              ></el-input>
            </el-form-item>
            <el-form-item label="消息类型：">
              <el-select size="small" v-model="form.messageType">
                <el-option
                  v-for="(item, index) in messageType"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发送类型：">
              <el-select size="small" v-model="form.sendType">
                <el-option
                  v-for="(item, index) in sendType"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发送状态：">
              <el-select size="small" v-model="form.status">
                <el-option
                  v-for="(item, index) in sendStatus"
                  :key="index"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发送时间：">
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="form.sendStartTime"
                  type="datetime"
                  :placeholder="'选择日期时间'"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="startTimeOption"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                ></el-date-picker>
                <div class="time_to_text" style="margin-top: 1px !important">
                  至
                </div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="form.sendEndTime"
                  type="datetime"
                  :placeholder="'选择日期时间'"
                  :picker-options="endTimeOption"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 145px; font-size: 12px"
                  default-time="23:59:59"
                  class="time2"
                  :clearable="false"
                ></el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="clearTimeSendTime()"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt
                  class="date_icon2"
                />
              </div>
            </el-form-item>
            <el-form-item>
              <div class="el-btn">
                <el-button
                  size="small"
                  :disabled="tableLoding"
                  class="search"
                  @click="
                    form.current = 1;
                    submitForm('formSearch');
                  "
                >
                  <i
                    class="el-icon-search"
                    style="display: inline-block; width: 14px; height: 12px"
                  ></i>
                  查询
                </el-button>
                <el-button size="small" class="reset" @click="resetForm"
                  >重置</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-box">
          <el-table
            ref="table"
            :data="tableData"
            tooltip-effect="light"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            v-loading="tableLoding"
          >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column
              label="群发主题"
              prop="massTheme"
            ></el-table-column>
            <el-table-column label="活动类型" prop="messageType">
              <template slot-scope="scope">
                {{ scope.row.messageType == "1" ? "商品卡片" : "图文消息" }}
              </template>
            </el-table-column>
            <el-table-column label="发送类型" prop="sendType">
              <template slot-scope="scope">
                <div v-if="scope.row.sendType == 1">定时发送</div>
                <div v-else-if="scope.row.sendType == 2">循环发送</div>
                <div v-else>立即发送</div>
                <!-- {{ scope.row.sendType == "1" ? "定时发送" : "立即发送" }} -->
              </template>
            </el-table-column>
            <el-table-column
              label="提交时间"
              prop="commitTime"
            ></el-table-column>
            <el-table-column label="发送时间" prop="sendTime" width="300px"></el-table-column>
            <el-table-column label="发送群数量" prop="groupIds">
              <template slot-scope="scope">
                {{ (scope.row.groupIds && scope.row.groupIds.length) || 0 }}
              </template>
            </el-table-column>
            <el-table-column label="发送状态" prop="status">
              <template slot-scope="scope">
                <div>
                  <span
                    class="circle"
                    :class="{ green: scope.row.status == '0' }"
                  ></span>
                  <!-- 1待发送 2已发送 3发送失败4未开始 5进行中 6已结束 -->
                  <!-- {{ scope.row.state == "1" ? "待发送" : "已发送" }} -->
                  <span v-if="scope.row.status == 1">待发送</span>
                  <span v-else-if="scope.row.status == 2">已发送</span>
                  <span v-else-if="scope.row.status == 3">发送失败
                    <el-tooltip class="item" effect="light" :content="scope.row.failReason" placement="top-start">
                        <span class="question_icon">?</span>
                    </el-tooltip>
                  </span>
                  <span v-else-if="scope.row.status == 4">未开始</span>
                  <span v-else-if="scope.row.status == 5">进行中</span>
                  <span v-else>已结束
                    <el-tooltip class="item" effect="light" :content="scope.row.overReason" placement="top-start">
                        <span class="question_icon">?</span>
                    </el-tooltip>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="300px">
              <template slot-scope="scope">
                <div class="control-button">
                  <el-button
                    class="operation"
                    type="text"
                    @click="handleCatch(scope.row)"
                    >查看</el-button
                  >
                  <div>
                  <el-button
                    class="operation"
                    type="text"
                    v-if="scope.row.sendType == 2 && (scope.row.status == 5 || scope.row.status == 6)"
                    @click="handleDaily(scope.row.id)"
                    >发送日志</el-button
                  >
                  <el-button type="text" disabled v-else style="color: #dddddd;margin-right: 10px;">发送日志</el-button>
                  </div>
                  <div>
                  <el-button
                    class="operation"
                    type="text"
                    v-if="scope.row.sendType == 2 && (scope.row.status == 5 || scope.row.status == 4)"
                    @click="cycleStop(scope.row.id)"
                    >停止</el-button
                  >
                  <el-button
                    class="operation"
                    type="text"
                    v-else-if="scope.row.sendType == 1 && scope.row.status == 4"
                    @click="cycleStop(scope.row.id)"
                    >停止</el-button
                  >
                  <el-button type="text" disabled v-else style="color: #dddddd;margin-right: 10px;">停止</el-button>
                  </div>
                  <el-button
                    class="operation"
                    type="text"
                    @click="handleCopy(scope.row)"
                    >复制</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页器 -->
          <div>
            <el-pagination
              background
              class="pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="form.current"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="form.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </template>
    </div>
    <!-- 停止确认弹窗 -->
    <el-dialog
      title="停止确认"
      :visible.sync="dialogSureStop"
      width="30%">
      <span>活动停止后不可重新开启，是否确定停止？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSureStop = false">取 消</el-button>
        <el-button type="primary" @click="sureStop()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 选择组或者群弹窗 -->
    <select-group-chat
      :visible.sync="showGroupDialog"
      @on-confirm="handleConfirm"
      :groupData="groupData"
    ></select-group-chat>
    <!-- 发送确认弹窗 -->
    <group-send
      :visible.sync="showSend"
      @on-confirm="handleConfim"
      v-if="showSend"
      :infoObj="sendInfo"
    ></group-send>
    <!-- 选择商品弹窗 -->
    <select-goods
      v-if="isShowGoods"
      :isShow="isShowGoods"
      :selectGoods="skuList"
      :skuSearch="true"
      @close="selectGoodsChange"
      :moduleType="true"
    ></select-goods>
    <!-- 发送日志弹窗 -->
    <cycle-daily
      v-if="isShowDaily"
      :isShow="isShowDaily"
      :cycleId="cycleId"
      @close="isShowDaily = false"
    >
    </cycle-daily>
  </div>
</template>

<script>
import selectGoods from "@/components/selectGoodsMonitor2";
import {
  getGroupList,
  getGroupRecord,
  uploadpic,
  saveDraft,
  getDraft,
  submitGroup,
  getCycleStop,
  getClear,
} from "@/api/marketing/dongdong";
import topTitle from "@/components/top-title.vue";
import selectGroupChat from "@/components/select-group-chat";
import groupSend from "@/components/group-send";
import { mapState } from "vuex";
import cycleDaily  from "@/components/cycleDaily.vue"
export default {
  name: "group_chart_market",
  components: {
    topTitle,
    selectGroupChat,
    groupSend,
    selectGoods,
    cycleDaily,
    getCycleStop,
    
  },
  data() {
    return {
      delId:0,//停止的id
      cycleId:0,//打开发送弹窗id
      tabIndex: "1",
      formData: {
        massTheme: "", // 活动主题
        messageType: 0, // 消息类型： 0 图文，1 商品卡片
        addPicture: true, // 添加图片
        addText: true, // 添加文本
        textMessageContent: "", // 文本内容
        sendType: 1, //  0：立即发送  1：定时发送
        sendTime: "",
        cardTitle: "",
        pushMainGraph: "",
      },
      groupData: [],
      // computeLoading: false,
      form: {
        current: 1,
        size: 10,
        massTheme: "",
        messageType: "",
        sendType: "",
        status: "",
        sendStartTime: "",
        sendEndTime: "",
      }, // 记录查询条件
      total: 0,
      messageType: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "图文消息",
          value: "0",
        },
        {
          label: "商品卡片",
          value: "1",
        },
      ],
      sendType: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "立即发送",
          value: "0",
        },
        {
          label: "定时发送",
          value: "1",
        },
        {
          label: "循环发送",
          value: "2",
        },
       
      ],
      // 发送状态 1待发送 2已发送 3发送失败4未开始 5进行中 6已结束
      sendStatus: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "待发送",
          value: "1",
        },
        {
          label: "已发送",
          value: "2",
        },
        {
          label: "发送失败",
          value: "3",
        },
        {
          label: "未开始",
          value: "4",
        },
        {
          label: "进行中",
          value: "5",
        },
        {
          label: "已结束",
          value: "6",
        },
      ],
      tableData: [],
      tableLoding: false,
      showGroupDialog: false,
      showSend: false,
      isShowDongTip: true,
      isShowGoods: false,
      skuList: [],
      disabledOption: {
        disabledDate: (date) => {
          var time = date.getTime();
          var flag = false;
          if (time > Date.now() + 90 * 8.64e7 || time < Date.now() - 8.64e7) {
            flag = true;
          }
          return flag;
        },
      },
      startTimeOption: {
        disabledDate: (date) => {
          var endTime = this.form.sendEndTime;
          var time = date.getTime();
          var isDisabled = false;
          if (endTime) {
            isDisabled = time > new Date(endTime).getTime();
          }
          return isDisabled;
        }
      },
      endTimeOption: {
        disabledDate: (date) => {
          var startTime = this.form.sendStartTime;
          var time = date.getTime();
          var isDisabled = false;
          if (startTime) {
            isDisabled = time < new Date(startTime).getTime();
          }
          return isDisabled;
        }
      },
      draftLoading: false,
      sendInfo: {},
      sendLoading: false,
      status: "", // ''(正常) catch（查看） copy（复制）
      circulate:{
        cycleStartTime:'',
        cycleEndTime:'',
        cycleExecutionType:0,//周期执行方式，0：按天、1：按周、2：按月
        cycleDay:1,//周期执行，每几天
        cycleDayWeekly:[],//周期执行，每星期的周几
        cycleDayMonthly:[],//周期执行，每月的几号
        cycleExecutionTime:'',//周期执行，具体执行时间点。格式 HH:mm:ss
      },//循环发送设置
      cycleDayWeeklys: [
        {
          value: 2,
          label: '周一'
        },
        {
          value: 3,
          label: '周二'
        },
        {
          value: 4,
          label: '周三'
        },
        {
          value: 5,
          label: '周四'
        },
        {
          value: 6,
          label: '周五'
        },
        {
          value: 7,
          label: '周六'
        },
        {
          value: 1,
          label: '周日'
        }
      ],
      cycleDayMonthlys: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      dialogSureStop:false,//停止确认弹窗
      isShowDaily:false,//发送日志弹窗
      startTimeCycle: {
        disabledDate: (date) => {
          var endTime = this.circulate.cycleEndTime;
          var time = date.getTime();
          var thisDay= new Date().getTime()
          var isDisabled = false;
          if( thisDay){
            isDisabled = time < thisDay - 24 * 60 * 60 * 1000;
          }
          if (endTime) {
            isDisabled = time > new Date(endTime).getTime() || time < thisDay- 24 * 60 * 60 * 1000;;
          }
          return isDisabled;
        }
      },
      endTimeCycle: {
        disabledDate: (date) => {
          var startTime = this.circulate.cycleStartTime;
          var time = date.getTime();
          var isDisabled = false;
          var thisDay= new Date().getTime()
          if (startTime) {
            isDisabled = time < new Date(startTime).getTime();
          }else{
            isDisabled = time < thisDay- 24 * 60 * 60 * 1000;;
          }
          return isDisabled;
        }
      },
    };
  },
  created() {
    // 调用埋点接口
    this.buriedPoint(1, '群聊营销', '客户营销', '咚咚群聊')
  },
  mounted() {
    this.initData();
    if (this.$route.query.industry) {
      this.tabIndex = 2
      // 我的使用策略跳转过来，发送时间取消默认状态，显示不填状态 
      // this.clearTimeSendTime()
      // this.submitForm()
    }
  },
  methods: {
    handleReturn() {
      this.status = "";
      this.tabIndex = "2";
    },
    handleCatch(data) {
      this.status = "catch";
      this.tabIndex = "1";
      this.initGroupData(data);
    },
    handleCopy(data) {
      this.status = "copy";
      this.tabIndex = "1";
      this.initGroupData(data);
    },
    handleSendChange() {
      if (this.formData.sendType === 0 || this.formData.sendType == 2) {
        this.formData.sendTime = "";
      }
    },
    //循环设置
    handleDayChange(){

    },
    handleConfim() {
      // 点击确定按钮
      console.log("点击确定按钮");
      this.showSend = false;
      var formData = this.formData;
      var circulate = this.circulate
      var groupIds = [],
        skus = [];
      groupIds = this.groupData.map((item) => {
        return item.id;
      });
      skus = this.skuList.map((item) => {
        return item.skuId;
      });
      var params = {
        massTheme: formData.massTheme,
        messageType: formData.messageType,
        pushMainGraph: formData.pushMainGraph,
        textMessageContent: formData.textMessageContent,
        cardTitle: formData.cardTitle,
        sendType: formData.sendType,
        sendTime: formData.sendTime,
        addPicture: formData.addPicture ? 1 : 0,
        addText: formData.addText ? 1 : 0,
        groupIds,
        skuIds: skus,

        cycleStartTime: circulate.cycleStartTime,
        cycleEndTime: circulate.cycleEndTime,
        cycleExecutionType: circulate.cycleExecutionType,
        cycleDay: circulate.cycleDay,
        cycleDayWeekly: circulate.cycleDayWeekly.join(","),
        cycleDayMonthly:  circulate.cycleDayMonthly.join(","),
        cycleExecutionTime: circulate.cycleExecutionTime,

        commitTime:new Date().getTime()
      };
      this.sendLoading = true;
      submitGroup(params).then((res) => {
        this.sendLoading = false;
        if (res.code == "1") {
          this.$message.success(res.message);
          this.tabIndex = '2';
          this.initData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleSubmit() {
      var formData = this.formData;
      var circulate = this.circulate
      var thisDay = Date.now()
      if (!this.groupData || this.groupData.length === 0) {
        this.$message.warning("请完善选择群组~");
        return;
      } else if (formData.messageType === 0 && 
      ((!formData.pushMainGraph && formData.addPicture) || (!formData.addPicture && !formData.addText))
      ) {
        this.$message.warning("请上传图片~");
        return;
      } else if (formData.sendType === 1 && !formData.sendTime) {
        this.$message.warning("请设置定时发送时间~");
        return;
      } else if (formData.messageType === 0 && !formData.textMessageContent && formData.addText) {
        this.$message.warning("请输入文本消息~");
        return;
      } else if (formData.messageType === 1) {
        if (!this.formData.cardTitle) {
          this.$message.warning("请输入卡片标题~");
          return;
        } else if (!this.skuList || this.skuList.length == 0) {
          this.$message.warning("请完善选择商品~");
          return;
        } else if (!formData.textMessageContent) {
          this.$message.warning("请输入文本消息~");
          return;
        }
      }
      if (formData.sendType === 1) {
        var now = Date.now();
        var sendTime = new Date(formData.sendTime).getTime();
        if (sendTime < now + 10 * 60 * 1000) {
          this.$message.warning("定时发送时间需在当前时间10分钟后~");
          return;
        }
      }

      if(formData.sendType === 2){
        this.formData.sendTime = ''
        if(!circulate.cycleStartTime || !circulate.cycleEndTime ){
          this.$message.warning("请完善循环活动时间~");
          return;
        }else if(new Date(circulate.cycleStartTime).getTime() > new Date(circulate.cycleEndTime).getTime()){
          this.$message.warning("活动起始时间不得大于结束时间");
          return;
        }

       if(circulate.cycleExecutionType === 0 ){
          if(!circulate.cycleDay){
            this.$message.warning("请完善推送时间~");
            return;
          } 
        }else if(circulate.cycleExecutionType === 1 ){
          if(circulate.cycleDayWeekly.length === 0){
            this.$message.warning("请完善推送时间~");
            return;
          }
        }else if(circulate.cycleExecutionType === 2 ){
          if(circulate.cycleDayMonthly.length === 0){
            this.$message.warning("请完善推送时间~");
            return;
          } 
        }

        if(!circulate.cycleExecutionTime){
          this.$message.warning("请完善推送时间点~");
          return;
        } 
      }
      this.sendInfo = {
        ...this.formData,
        ...this.circulate,
        groupData: this.groupData,
      };
      console.log("this.sendInfo:", this.sendInfo);


      if(formData.sendType === 2){
        if(!circulate.cycleStartTime || !circulate.cycleEndTime ){
          this.$message.warning("请完善循环活动时间~");
          return;
        }else if(new Date(circulate.cycleStartTime).getTime() > new Date(circulate.cycleEndTime).getTime()){
          this.$message.warning("活动起始时间不得大于结束时间");
          return;
        }

      if(circulate.cycleExecutionType === 0 ){
          if(!circulate.cycleDay){
            this.$message.warning("请完善推送时间~");
            return;
          } 
        }else if(circulate.cycleExecutionType === 1 ){
          if(circulate.cycleDayWeekly.length === 0){
            this.$message.warning("请完善推送时间~");
            return;
          }
        }else if(circulate.cycleExecutionType === 2 ){
          if(circulate.cycleDayMonthly.length === 0){
            this.$message.warning("请完善推送时间~");
            return;
          } 
        }

        if(!circulate.cycleExecutionTime){
          this.$message.warning("请完善推送时间点~");
          return;
        } 
      }

      this.showSend = true;
    },
    delItem(item, index) {
      this.skuList.splice(index, 1);
    },
    //停止
    cycleStop(row){
      this.delId = row
      this.dialogSureStop = true
    },
    sureStop(){
      this.dialogSureStop = false
      getCycleStop({id:this.delId}).then(res => {
        console.log(res);
         if (res.code == "1") {
          this.$message.success(`停止成功`);
          this.getDataRecord()
        } else {
          this.delTaskDialog = false
          this.$message.error(res.message);
        }
        this.delTaskDialog = false
      })
    },
    getDraftData() {
      getDraft().then((res) => {
        var draftData = res.data;
        this.initGroupData(draftData);
      });
    },
    initGroupData(draftData) {
      this.formData = {
        massTheme: draftData.massTheme === null ? '' : draftData.massTheme,
        messageType: draftData.messageType || 0,
        textMessageContent: draftData.textMessageContent || '',
        sendType: draftData.sendType === null ? 0 : draftData.sendType,
        sendTime: draftData.sendTime,
        cardTitle: draftData.cardTitle === null ? '' : draftData.cardTitle,
        pushMainGraph: draftData.pushMainGraph || '',
        addPicture: (draftData.addPicture == "1" || draftData.addPicture === null) ? true : false,
        addText: (draftData.addText == "1" || draftData.addPicture === null) ? true : false,
      };
      if(this.status == "copy"){
        this.formData.sendTime = ""
      }
      this.circulate = {
        cycleStartTime: draftData.cycleStartTime,
        cycleEndTime: draftData.cycleEndTime,
        cycleExecutionType: draftData.cycleExecutionType || 0,
        cycleDay: draftData.cycleDay,
        cycleDayWeekly:[],
        cycleDayMonthly:[],
        cycleExecutionTime: draftData.cycleExecutionTime,
      }
      if(draftData.cycleDayWeekly){
        let arr = draftData.cycleDayWeekly.split(',')
        this.circulate.cycleDayWeekly = arr.map(Number)
        this.circulate.cycleDayWeekly.forEach((item,index)=>{
           if(item == 0 ){
            this.circulate.cycleDayWeekly.splice(index, 1)
           }
        })
      }
      if(draftData.cycleDayMonthly){
        let add2 = draftData.cycleDayMonthly.split(',')
        this.circulate.cycleDayMonthly = add2.map(Number)
        this.circulate.cycleDayMonthly.forEach((item,index)=>{
           if(item == 0 ){
            this.circulate.cycleDayMonthly.splice(index, 1)
           }
        })
      }
      
      console.log("this.circulate",this.circulate)

      this.skuList = draftData.skus || [];
      this.skuList = this.skuList.filter((item) => {
        return item;
      });
      this.skuList.map((item) => {
        item.wareTitle = item.skuName;
      });
      var groupData = [];
      if (draftData.groups && draftData.groups.length > 0) {
        draftData.groups.forEach((item) => {
          var subGroups = item.subGroups;
          if (subGroups) {
            groupData.push(...subGroups);
          }
        });
      }

      this.groupData = groupData;
    },
    clearAll() {
      this.formData = {
        massTheme: "", // 活动主题
        messageType: 0, // 消息类型 0.
        addPicture: true, // 添加图片
        addText: true, // 添加文本
        textMessageContent: "", // 文本内容
        sendType: 1, //  0：立即发送  1：定时发送
        sendTime: "",
        cardTitle: "",
        pushMainGraph: "",
      };
      this.circulate={
        cycleStartTime:'',
        cycleEndTime:'',
        cycleExecutionType:0,//周期执行方式，0：按天、1：按周、2：按月
        cycleDay:1,//周期执行，每几天
        cycleDayWeekly:[],//周期执行，每星期的周几
        cycleDayMonthly:[],//周期执行，每月的几号
        cycleExecutionTime:'',//周期执行，具体执行时间点。格式 HH:mm:ss
      },
      this.groupData = [];
      this.skuList = [];
      getClear();
    },
    showGoodsDialog() {
      this.isShowGoods = true;
    },
    selectGoodsChange(val) {
      console.log("skuList:", val);
      if (val) {
        if (val.length > 4) {
          this.$message.warning("每次最多添加4个商品！");
          return;
        }
        this.skuList = val;
      }
      this.isShowGoods = false;
    },
    // 发送日志
    handleDaily(index){
      console.log("点击打开弹窗")
      this.cycleId=index
      this.isShowDaily = true
    },
    handleSaveDraft() {
      var formData = this.formData;
      var circulate = this.circulate;
      let thisDay =new Date().getTime()
      var groupIds = [],
        skus = [];
      if (!this.groupData || this.groupData.length === 0) {
        this.$message.warning("请完善选择群组~");
        return;
      }

      if (this.groupData && this.groupData.length > 0) {
        groupIds = this.groupData.map((item) => {
          return item.id;
        });
      }

      if (this.skuList && this.skuList.length > 0) {
        skus = this.skuList.map((item) => {
          return item && item.skuId;
        });
      }
     
      if(formData.sendType === 2){
        this.formData.sendTime = ''
        if(!circulate.cycleStartTime || !circulate.cycleEndTime ){
          this.$message.warning("请完善循环活动时间~");
          return;
        }else if(new Date(circulate.cycleStartTime).getTime() > new Date(circulate.cycleEndTime).getTime()){
          this.$message.warning("活动起始时间不得大于结束时间");
          return;
        }

       if(circulate.cycleExecutionType === 0 ){
          if(!circulate.cycleDay){
            this.$message.warning("请完善推送时间~");
            return;
          } 
        }else if(circulate.cycleExecutionType === 1 ){
          if(circulate.cycleDayWeekly.length === 0){
            this.$message.warning("请完善推送时间~");
            return;
          }
        }else if(circulate.cycleExecutionType === 2 ){
          if(circulate.cycleDayMonthly.length === 0){
            this.$message.warning("请完善推送时间~");
            return;
          } 
        }

        if(!circulate.cycleExecutionTime){
          this.$message.warning("请完善推送时间点~");
          return;
        } 
      }

      var param = {
        textMessageContent: formData.textMessageContent,
        sendType: formData.sendType,
        sendTime: formData.sendTime,
        skuIds: skus,
        addPicture: formData.addPicture ? 1 : 0,
        addText: formData.addText ? 1 : 0,
        cardTitle: formData.cardTitle,
        groupIds,
        massTheme: formData.massTheme,
        messageType: formData.messageType,
        pushMainGraph: formData.pushMainGraph,

        cycleStartTime: circulate.cycleStartTime,
        cycleEndTime: circulate.cycleEndTime,
        cycleExecutionType: circulate.cycleExecutionType,
        cycleDay: circulate.cycleDay,
        cycleExecutionTime: circulate.cycleExecutionTime,
        cycleDayWeekly:[],
        cycleDayMonthly:[],
        commitTime:new Date().getTime()
      };
      // cycleDayWeekly: circulate.cycleDayWeekly.join(","),
      // cycleDayMonthly:  circulate.cycleDayMonthly.join(","),
      if(circulate.cycleDayWeekly){
        param.cycleDayWeekly=circulate.cycleDayWeekly.join(",")
      }
      if(circulate.cycleDayMonthly){
        param.cycleDayMonthly=circulate.cycleDayMonthly.join(",")
      }
      console.log("param:", param);
      this.draftLoading = true;
      saveDraft(param).then((res) => {
        this.draftLoading = false;
        if (res.code == "1") {
          this.$message.success("保存成功！");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleChange(file, fileList) {
      const isLtSize = file.size < 1024 * 1024 * 0.5;
      if (!isLtSize) {
        this.$message.error("限制格式: jpg、 png，请上传小于500k的图片！");
        this.$refs.upload.clearFiles();
      } else {
        this.fileList = fileList;
        // this.$refs.upload.$children[1].$el.style.display = "none";
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          if (res.code === 1) {
            this.formData.pushMainGraph = res.data;
            this.$refs.upload.clearFiles();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    initData() {
      // 是否显示未创建提示
      // getGroupList().then((res) => {
      //   if (!res.data) {
      //     this.isShowDongTip = true;
      //   }
      // });
      // 获取群发记录
      this.form.sendStartTime = this.getDateStr(0) + " 00:00:00";
      this.form.sendEndTime = this.getDateStr(90) + " 23:59:59";
      this.getDataRecord();
      // 获取草稿
      this.getDraftData();
    },
    submitForm(formName) {
      this.getDataRecord();
    },
    getDataRecord() {
      (this.tableLoding = true),
        getGroupRecord(this.form).then((res) => {
          this.tableLoding = false;
          if (res.code === 1) {
            this.tableData = res.data.records;
            this.total = res.data.total;
          }
        });
    },
    delGroup(item, index) {
      this.groupData.splice(index, 1);
    },
    navigate() {
      window.open("http://kf.jd.com");
    },
    handleConfirm(data) {
      // console.log(data)
      this.groupData = data;
      this.showGroupDialog = false;
    },
    showGroup() {
      this.showGroupDialog = true;
    },
    handleSwitch(index) {
      this.tabIndex = index;
      if (index == "1") {
        this.status = "";
      }
    },
    clearTimeSendTime() {
      this.form.sendStartTime = '';
      this.form.sendEndTime = '';
    },
    clearCycleTime(){
      this.circulate.cycleStartTime = '';
      this.circulate.cycleEndTime = '';
    },
    clearCycleSendTime(){
      this.circulate.cycleExecutionTime=''
    },
    resetForm() {
      for (var key in this.form) {
        this.form[key] = "";
      }
      this.form["current"] = 1;
      this.form["size"] = 10;
      this.getDataRecord();
    },
    handleSizeChange(size) {
      this.form.size = size;
      this.getDataRecord();
    },
    handleCurrentChange(current) {
      this.form.current = current;
      this.getDataRecord();
    },
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
    adjustClass() {
      var res = "";
      if (this.formData.messageType === 0) {
        if (!this.formData.addPicture && !this.formData.addText) {
          res = "type1";
        } else if (!this.formData.addPicture) {
          res = "type2";
        } else if (!this.formData.addText) {
          res = "type3";
        }
      }
      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
.circle {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  vertical-align: middle;
  background-color: #ffb95e;
  margin-right: 8px;
  &.green {
    background-color: #49c568;
  }
}
.box-shadow {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: #fff;
}
.step-box-total {
  position: relative;
  &::before {
    content: "";
    display: block;
    width: 1px;
    height: calc(100% - 25px);
    position: absolute;
    background-color: rgb(246, 246, 246);
    left: 37px;
    // z-index: ;
    top: 25px;
  }
}
.add-good-btn {
  font-size: 13px !important;
  vertical-align: middle;
  i {
    display: inline-block;
    font-size: 12px;
    transform: scale(0.8);
  }
  color: #7f85e9;
  background: #f7f8fe;
  width: 90px;
  height: 28px;
  border-color: #aeb3f1;
  &:hover {
    color: #7f85e9;
    background: #f7f8fe;
    border-color: #aeb3f1 !important;
  }
  &.is-disabled {
    color: #cccccc;
    background: #f6f6f6;
    border-color: #cccccc !important;
  }
}
.group-chat-box {
  margin: 11px 20px;
  min-width: 1220px;
  .tip-box {
    background: #fafafa;
    margin: 0 28px;
    color: #333;
    border-radius: 3px;
    height: 48px;
    line-height: 48px;
    padding-left: 12px;
    span {
      vertical-align: middle;
    }
    img {
      width: 14px;
      height: 14px;
      vertical-align: middle;
      margin-right: 8px;
    }
    .url {
      color: #7f85e9;
      cursor: pointer;
    }
    .el-button {
      margin-left: 20px;
      height: 28px;
      width: 76px;
      box-sizing: border-box;
    }
  }

  .tab-line {
    font-size: 14px;
    color: #666666;
    border-bottom: 1px solid #dddddd;
    margin: 20px 28px 0 28px;
    .tab-item {
      // padding: 15px 0;
      text-align: center;
      width: 106px;
      height: 36px;
      line-height: 36px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      margin-right: 2px;
      border: 1px solid #dddddd;
      border-bottom: none;
      // &:first-child{
      //   margin-right: 22px;
      // }
      span {
        position: absolute;
        width: 100%;
        left: 50%;
        height: 2px;
        transform: translateX(-50%);
        bottom: -2px;
        display: none;
      }
      &.active {
        border-top: 2px;
        span {
          display: block;
          background: #fff;
        }
      }
    }
  }
  .step1-box {
    padding: 20px 27px 0 27px;
    font-size: 14px;
    color: #333;
    .form-item {
      margin-bottom: 16px;
      & > div {
        display: inline-block;
      }
      .item-label {
        width: 135px;
        text-align: right;
        padding-right: 8px;
        box-sizing: border-box;
        vertical-align: text-top;
        line-height: 32px;
      }
      .item-value {
        width: 728px;
        vertical-align: text-top;
        .select-group-box {
          .select-header {
            background: #f6f6f6;
            height: 48px;
            line-height: 48px;
            .height-num {
              margin: 0 4px;
            }
            .add-btn {
              margin: 0 12px 0 8px;
              font-size: 13px !important;
              i {
                display: inline-block;
                font-size: 12px;
                transform: scale(0.8);
              }
              color: #7f85e9;
              background: #f7f8fe;
              width: 64px;
              height: 28px;
              border-color: #aeb3f1;
              &:hover {
                color: #7f85e9;
                background: #f7f8fe;
                border-color: #aeb3f1 !important;
              }
              &.is-disabled {
                color: #cccccc;
                background: #f6f6f6;
                border-color: #cccccc !important;
              }
            }
          }
        }
        .people-group {
          border: 1px solid rgba(246, 246, 246, 1);
          color: #999;
          padding-top: 14px;
          // margin-bottom: 20px;
          .group-item {
            // padding: 14px 12px;
            position: relative;
            display: inline-block;
            line-height: 32px;
            height: 32px;
            border: 1px solid rgba(238, 238, 238, 1);
            border-radius: 2px;
            color: #666666;
            margin-left: 10px;
            margin-bottom: 14px;
            position: relative;
            .group-name {
              width: 210px;
              box-sizing: border-box;
              display: inline-block;
              white-space: nowrap;
              text-overflow: ellipsis;
              text-align: center;
              overflow: hidden;
              // border:1px solid #CCCCCC;
              padding: 0 22px;
            }
            .close {
              display: none;
              position: absolute;
              right: -6px;
              top: -6px;
              width: 16px;
              height: 16px;
              border-radius: 50%;
              cursor: pointer;
              background-color: #fe4d45;
              // display: none;
              &:before,
              &:after {
                position: absolute;
                top: 4px;
                left: 7px;
                content: " ";
                height: 8px;
                width: 2px;
                background-color: #fff;
              }
              &:before {
                transform: rotate(45deg);
              }
              &:after {
                transform: rotate(-45deg);
              }
            }
            &:hover .close {
              display: inline-block;
            }
          }
        }
      }
      .activity-theme {
        // .el-input {
        //   @media screen and (max-width: 1366px) {
        //     width: 800px;
        //   }
        // }
      }
    }
    &.edit-content {
      position: relative;
      .form-item {
        line-height: 20px;
      }
      .item-label {
        line-height: 20px;
      }
      .message-type {
        margin-bottom: 20px;
      }
      .add-pic {
        margin-bottom: 10px;
        .item-label {
          padding-right: 20px;
        }
      }
      .main-graph {
        margin-bottom: 30px;
      }
      .upload-wrap {
        background: #f9fafb;
        border-radius: 6px;
        padding: 12px;
        border: 1px solid #eeeeee;
        width: 254px;
        height: 222px;
        .upload-img {
          width: 230px;
          height: 150px;
          object-fit: cover;
        }
        .upload-box {
          width: 230px;
          height: 150px;
          border: 1px solid #eeeeee;
          background: #ffffff;
          border-radius: 2px;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          i {
            color: #999;
            font-size: 26px;
          }
          .text {
            margin-top: 7px;
            font-size: 12px;
            color: #666;
          }
        }
        .upload-limit {
          color: #999;
          font-size: 12px;
          line-height: 17px;
          p:first-child {
            margin: 10px 0 4px 0;
          }
        }
      }
      .textarea-wrap {
        padding: 12px;
        background: #f9fafb;
        border: 1px solid #eeeeee;
        /deep/.el-textarea__inner {
          padding: 12px !important;
        }
        .limit {
          color: #999;
          text-align: right;
          font-size: 13px;
          padding-top: 10px;
        }
      }
    }
    &.send {
      padding-top: 34px;
      .send-wrap {
        padding-left: 30px;
      }
      &.type1 {
        padding-bottom: 300px;
      }
      &.type3 {
        padding-bottom: 50px;
      }
      &.type2 {
        padding-bottom: 110px;
      }
    }
  }
  .circulateData{
      margin: 15px 0;
      padding: 12px;
      background: #FAFAFA;
      border-radius: 4px 4px 4px 4px;
      width: 53%;
      //循环发送
      /deep/.dayTimeSelect .el-input--small .el-input__inner{
        width: 125px;
        position: relative;
      }
    .dayTimeSelect{
      .date_icon1{
        position: absolute;
        /* top: 10px; */
        right: 105px;
        height: 32px;
        line-height: 32px;
        width: 16px;
        font-size: 16px;

        display: none;
        cursor: pointer;
      }
      .date_icon3{
        position: absolute;
        /* top: 10px; */
        right: 105px;
        height: 32px;
        line-height: 32px;
        width: 16px;
        font-size: 16px;
      }
    }
    .dayTimeSelect:hover .date_icon1{
      display: inline;
    }
    .dayTimeSelect:hover .date_icon3{
      display: none;
    }
    .cycleTipbox{
      background: #FFFAEE;
      border-radius: 2px 2px 2px 2px;
      opacity: 1;
      display: inline-block;
      padding: 0 12px;
      .cont{
        padding: 0 10px;
        height: 18px;
        font-size: 13px;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
      }
    }
  }
  .foot {
    border-top: 1px solid #f6f6f6;
    padding: 24px 30px;
    margin-top: 50px;
    .btn {
      width: 188px;
    }
  }
}
.phone-wrap {
  position: absolute;
  top: 60px;
  left: 1100px;
  @media screen and (max-width: 1609px) {
    left: 950px;
  }
  .phone-preview {
    width: 255px;
    position: relative;
    .bg {
      width: 255px;
    }
    .preview-text {
      text-align: center;
      padding-top: 25px;
      font-size: 16px;
      color: #333;
      line-height: 22px;
    }
    .content-wrap {
      position: absolute;
      padding-right: 15px;
      top: 134px;
      left: 19px;
      max-height: 305px;
      overflow: auto;
      .img-wrap {
        text-align: left;
        // width: 215px;
        img {
          width: 96px;
          height: 96px;
          border-radius: 6px;
          object-fit: cover;
          margin-top: 4px;
        }
        .empty {
          width: 215px;
          background: #f8f8f8;
          text-align: center;
          font-size: 14px;
          color: #c3cbd6;
          border-radius: 4px;
          height: 100px;
          line-height: 100px;
        }
      }
      .chat-record {
        top: 100px;
        .chat-item {
          margin-top: 10px;
          .chat-icon {
            width: 30px;
            display: inline-block;
            vertical-align: text-top;
            margin-right: 5px;
            border-radius: 5px;
          }
          .chat-right{
            display: inline-block;
            vertical-align: text-top;
            width: 175px;
            .shop-title{
              color: #848797;
              font-size: 12px;
              // margin-left: 5px;
              transform: scale(0.8) translateX(-4px) translateY(-2px);
              display: inline-block;
              letter-spacing: 1.5px;
            }
          }
          .message-content {
            word-break: break-all;
            // display: inline-block;
            // vertical-align: text-top;
            margin-top: 6px;
            width: 175px;
            box-sizing: border-box;
            padding: 5px;
            background-color: #fff;
            font-size: 12px;
            line-height: 18px;
            color: #333;
            position: relative;
            &::before {
              display: block;
              content: "";
              width: 0;
              height: 0;
              border-top: 6px solid transparent;
              border-right: 12px solid #fff;
              border-bottom: 6px solid transparent;
              position: absolute;
              left: -6px;
              top: 3px;
            }
            .card-title {
              font-size: 12px;
            }
            .goods-record {
              .record-item {
                padding: 6px 0;
                border-bottom: 1px solid #F3F4F5;
                img {
                  width: 45px;
                  height: 45px;
                  object-fit: cover;
                  vertical-align: text-top;
                  margin-right: 4px;
                }
                .detail {
                  display: inline-block;
                  width: 115px;
                  vertical-align: text-top;
                  color: #333;
                  p {
                    width: 100%;
                    line-height: 15px;
                    // overflow: hidden;
                    // text-overflow: ellipsis;
                    // white-space: nowrap;

                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                  }
                  .num {
                    color: #fe4d45;
                    margin-top: 2px;
                  }
                }
                &:last-child{
                  border-bottom: none;
                }
              }
            }
          }
        }
      }
    }
  }
}
.shop-card {
  .form-item {
    .item-label {
      line-height: 32px !important;
    }
    &.master-map-push {
      .item-label {
        line-height: 28px !important;
      }
      .add-shop-tip {
        display: inline-block;
        vertical-align: middle;
        margin-left: 12px;
        img {
          vertical-align: middle;
          margin-right: 4px;
        }
        span {
          color: #999;
          vertical-align: middle;
          font-size: 12px;
        }
      }
      .goods-list {
        background-color: #f9fafb;
        padding: 12px;
        display: inline-block;
        margin: 12px 0 20px 0;
        .goods-item {
          vertical-align: text-bottom;
          display: inline-block;
          margin-right: 12px;
          position: relative;
          .hover-show {
            display: none;
            position: absolute;
            width: 110px;
            height: 110px;
            background: rgba($color: #000000, $alpha: 0.3);
            top: 0;
            text-align: center;
            .del {
              width: 56px;
              height: 24px;
              border-radius: 12px;
              font-size: 12px !important;
              margin-top: 81px;
              letter-spacing: 0.7px;
            }
          }
          &:hover {
            .hover-show {
              display: block;
            }
          }
          &:last-child {
            margin-right: 0;
          }
          .img-wrap {
            height: 110px;
            img {
              width: 110px;
              height: 110px;
              object-fit: cover;
            }
          }
          p {
            width: 110px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 12px;
            color: #666;
            line-height: 17px;
            &:nth-child(2) {
              margin: 8px 0 4px 0;
            }
          }
        }
      }
    }
  }
}

/** 群发记录  */
.form-box {
  padding-top: 20px;
  .el-input,
  .el-select {
    width: 280px;
  }
  /deep/.el-form-item__label {
    padding-right: 0;
  }
  /deep/.el-form-item {
    margin-right: 10px;
    margin-bottom: 16px;
    &:nth-child(4) {
      // margin-right: 0;
    }
  }
  .el-btn {
    padding-left: 50px;
    .search {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }
    .reset {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
}
.table-box {
  padding: 4px 28px 0 28px;
  min-height: 500px;
}
.pagination {
  text-align: right;
  padding: 50px 0;
}
/** 步骤条 */
.step-bar {
  // background: #fafafa;
  position: relative;
  padding-left: 12px;
  margin-left: 29px;
  margin-bottom: 14px;
  width: -webkit-calc(100% - 80px);
  width: -moz-calc(100% - 80px);
  width: calc(100% - 80px);
  .serial {
    width: 22px;
    height: 22px;
    border-radius: 22px;
    color: #fff;
    line-height: 22px;
    text-align: center;
    display: inline-block;
    line-height: 22px;
    position: absolute;
    left: -29px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
  }
  .division {
    display: inline-block;
    width: 3px;
    height: 14px;
    margin-right: 8px;
    vertical-align: middle;
  }
  .name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    line-height: 32px;
    vertical-align: middle;
  }
}
.control-button { 
  display: flex;
  .el-button {
    width: auto;
    margin-left: 0 !important;
    padding: 0 !important;
  }
  .operation {
    cursor: pointer;
    color: #7f85e9;
    margin-right: 10px;
    // &:first-child {
    //   margin-right: 10px;
    // }
    &:hover {
      color: #fe4d45;
    }
  }
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #fe4d45 !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #fe4d45;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 8px;

  &:hover {
    color: #fe4d45 !important;
    border: 1px solid #fe4d45;
  }
}


</style>